<template>
<div>  
  <main class="container-fluid">
    <section class="row">
      <div class="col-4 px-3 py-3 d-none d-md-flex"></div> 
      <div class="col-24 col-md-16 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5">
        <div class="col d-column"> 
          <h1 class="title pt-2 mb-0" v-text="$ml.with(nameEmpresa).get('dashTitle')"></h1>
          <h1 class="title"><span class="pb-2" v-text="$ml.get('overviewSubTitle')">Uma visão gerencial da sua conta só para você</span></h1> 
 
          <div class="card mb-3"> 
            <div class="card-body">  
 
              <div class="row">
                <h4 v-text="$ml.get('vulnerabilities')" >Vulnerabilidades</h4>
              </div>
              <div class="row">
                <div class="ml-0 p-0">
                  <apexchart class="ml-0 p-0" width="220" type="donut" :options="vulnerabilitiesChart" :series="vulnerabilitiesChart.series"></apexchart>
                </div>

                <div class="col-11 mt-2">
                  <h5 class="mt-3" v-text="$ml.get('approvedVulnerabilities')">Vulnerabilidades aprovadas</h5>
                  <h5 class="mb-3">{{vulnerabilitiesTotal  }}</h5> 
                  <div class="row mt-1" v-if="vulnerabilitiesChart.series">  
                    <div class="mr-3"> 
                      <div class="row">
                        <Impact impact='impact-critical' class="mt-1 mr-1"/> 
                        <span v-text="$ml.get('critical')"></span> 
                      </div>
                      <h5 class="my-1">{{vulnerabilitiesChart.series[0] || 0}}</h5>
                    </div> 

                    <div class="mr-3"> 
                      <div class="row">
                        <Impact impact='impact-high' class="mt-1 mr-1"/> 
                        <span v-text="$ml.get('high')"></span> 
                      </div>
                      <h5 class="my-1">{{vulnerabilitiesChart.series[1] || 0}}</h5>
                    </div> 

                    <div class="mr-3"> 
                      <div class="row">
                        <Impact impact='impact-medium' class="mt-1 mr-1"/>
                        <span v-text="$ml.get('medium')"></span> 
                      </div>
                      <h5 class="my-1">{{vulnerabilitiesChart.series[2] || 0}}</h5>
                    </div> 

                    <div class="mr-3"> 
                      <div class="row">
                        <Impact impact='impact-low' class="mt-1 mr-1"/> 
                        <span v-text="$ml.get('low')"></span> 
                      </div>
                      <h5 class="my-1">{{vulnerabilitiesChart.series[3] || 0}}</h5>
                    </div> 

                    <div class="mr-3"> 
                      <div class="row">
                        <Impact impact='impact-none' class="mt-1 mr-1"/> 
                        <span v-text="$ml.get('informative')">Informativo</span> 
                      </div>
                      <h5 class="my-1">{{vulnerabilitiesChart.series[4] || 0}}</h5>
                    </div> 
                  </div>  
                </div> 

                <div class="col-24 col-sm-6" v-if="topTargets.length">
                  <h5 class="mt-4 mb-3">Top {{$ml.get('scope')}}s</h5>  
                  <ProgressImpact v-if="topTargets[0]" :targets="topTargets[0]" class="mt-1 mr-1"/>  
                  <ProgressImpact v-if="topTargets[1]" :targets="topTargets[1]" class="mt-1 mr-1"/> 
                  <ProgressImpact v-if="topTargets[2]" :targets="topTargets[2]" class="mt-1 mr-1"/>  
                </div> 
              </div>
  
            </div>
          </div>

          <div style="margin-left: -.6%; margin-right: -.6%;"> 
            <div class="row w-100 mt-2"> 

<!-- submissions -->
              <div class="col-sm-8 p-2 cardOverview">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title" v-text="$ml.get('reportsSent')">Relatórios enviados</h5>
                    <apexchart type="donut" :width="widthChart" :height="heightChart" :options="submissionsChart" :series="submissionsChart.series"></apexchart>
                  </div>
                  <hr>
                  <div class="card-body py-0 row">
                    <div class="col-18">
                      <h6 v-text="$ml.get('medianTimeToFirstResponse')">Median time to first response</h6> 
                      <h6 class="text-muted m-0 p-0">{{$ml.with((metrics.program_sla_time_to_first_response || 0) + 'd').get('target')}}</h6>
                    </div>
                    <div class="col-6 d-flex justify-content-center align-items-center">
                      <h5 class="p-0 m-0">{{metrics.average_time_to_first_response || 0}}d</h5> 
                    </div>
                  </div> 
                  <hr>
                  <div class="card-body py-0 pb-3 row">
                    <div class="col-18">
                      <h6 class="">{{$ml.get('missedResponseTargetsReportsSent')}}</h6>
                      <h6 class="text-muted m-0 p-0">{{metrics.amount_of_missed_first_response || 0}} {{$ml.get('reports')}}</h6> 
                    </div>
                    <div class="col-6 d-flex justify-content-center align-items-center">
                      <h5 v-if="submissionsChart.total > 0 && submissionsChart.total != null && submissionsChart.total != undefined" class="p-0 m-0">{{
                        parseFloat(((metrics.amount_of_missed_first_response / submissionsChart.total) *100).toFixed(1)) || 0}}%
                      </h5> 
                      <h5 v-else>0%</h5>
                    </div>
                  </div> 
                </div>
              </div>

<!-- resolved -->
              <div class="col-sm-8 p-2 cardOverview">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title" v-text="$ml.get('resolved')"></h5>
                      <apexchart type="donut" :width="widthChart" :height="heightChart" :options="resolvedChart" :series="resolvedChart.series"></apexchart>
                  </div>
                  <hr>
                  <div class="card-body py-0 row">
                    <div class="col-18">
                      <h6 v-text="$ml.get('medianTimeToResolution')">Median time to resolution</h6>
                      <h6 class="text-muted m-0 p-0">{{$ml.with((metrics.program_sla_time_to_resolution || 0) + 'd').get('target')}}</h6> 
                    </div>
                    <div class="col-6 d-flex justify-content-center align-items-center">
                      <h5 class="p-0 m-0">{{metrics.average_time_to_resolution || 0}}d</h5> 
                    </div>
                  </div> 
                  <hr>
                  <div class="card-body py-0 pb-3 row">
                    <div class="col-18">
                      <h6 class="">{{$ml.get('missedResponseTargetsResolved')}}</h6>
                      <h6 class="text-muted m-0 p-0">{{metrics.amount_of_missed_resolution || 0}} {{$ml.get('reports')}}</h6>  
                    </div>
                    <div class="col-6 d-flex justify-content-center align-items-center">
                      <h5 v-if="submissionsChart.total > 0 && submissionsChart.total != null && submissionsChart.total != undefined" class="p-0 m-0">{{
                        parseFloat(((metrics.amount_of_missed_resolution / submissionsChart.total) *100).toFixed(1)) || 0}}% 
                      </h5>
                      <h5 v-else>0%</h5>
                    </div> 
                  </div> 
                </div>
              </div> 
          
<!-- bounty awarded -->
              <div class="col-sm-8 p-2 cardOverview">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title" v-text="$ml.get('bountyAwarded')"></h5>
                    <apexchart type="donut" :width="widthChart" :height="heightChart" :options="awardedBountiesChart" :series="awardedBountiesChart.series"></apexchart>
                  </div>
                  <hr>
                  <div class="card-body py-0 row">
                    <div class="col-18">
                      <h6 v-text="$ml.get('averageTimeToBounty')">Average time to bounty</h6>
                      <h6 class="text-muted m-0 p-0">{{$ml.with((metrics.program_sla_time_to_bounty || 0) + 'd').get('target')}}</h6>
                    </div>
                    <div class="col-6 d-flex justify-content-center align-items-center">
                      <h5 class="p-0 m-0">{{metrics.average_time_to_bounty || 0}}d</h5> 
                    </div>
                  </div>
                  <hr>
                  <div class="card-body py-0 pb-3 row">
                    <div class="col-18">
                      <h6 class="">{{$ml.get('missedResponseTargetsBounty')}}</h6>
                      <h6 class="text-muted m-0 p-0">{{metrics.amount_of_missed_payment || 0}} {{$ml.get('reports')}}</h6>  
                    </div>
                    <div class="col-6 d-flex justify-content-center align-items-center">
                      <h5 v-if="metrics.amount_of_payable_reports > 0 && metrics.amount_of_payable_reports != null && metrics.amount_of_payable_reports != null" class="p-0 m-0">{{
                        parseFloat(((metrics.amount_of_missed_payment / metrics.amount_of_payable_reports) *100).toFixed(1)) || 0}}% 
                      </h5>
                      <h5 v-else>0%</h5>
                    </div> 
                  </div> 
                </div>
              </div>
              
<!-- Top submission type -->
              <div class="col-sm-16 p-2 cardOverview" v-if="topSubmissionTypes.length">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title mb-2" v-text="$ml.get('topReportedCWE')" >CWE mais relatado</h5>
                      <div class="row" v-if="topSubmissionTypes.length">
                        <div class="col-24">
                          <div class="progress" style="margin-top: 10px;">  
                            <div class="progress-bar p-b-r "  
                              v-b-tooltip.hover 
                              :title="`${topSubmissionTypes[0]?.quantity} ${$ml.get('reports')} ${ parseFloat(((topSubmissionTypes[0]?.quantity / sumSubmissionTypes) * 100).toFixed(1))}%`"
                              :style="`width: ${parseFloat((topSubmissionTypes[0]?.quantity / sumSubmissionTypes) * 100)}%`"> 
                            </div> 
                            <div class="progress-bar p-b-impact-low col"> </div> 
                          </div> 
                          <label>{{topSubmissionTypes[0]?.weakness_type}} - {{topSubmissionTypes[0]?.weakness_external_id}}</label>
          
                          <div class="progress mt-2">
                            <div class="progress-bar p-b-r"  
                              v-b-tooltip.hover 
                              :title="`${topSubmissionTypes[1]?.quantity} ${$ml.get('reports')} ${ parseFloat(((topSubmissionTypes[1]?.quantity / sumSubmissionTypes) * 100).toFixed(1))}%`"
                              :style="`width: ${parseFloat((topSubmissionTypes[1]?.quantity / sumSubmissionTypes) * 100)}%`"> 
                            </div> 
                            <div class="progress-bar p-b-impact-low col"> </div>
                          </div>
                          <label>{{topSubmissionTypes[1]?.weakness_type}} - {{topSubmissionTypes[1]?.weakness_external_id}}</label>
          
                          <div class="progress mt-2">
                            <div class="progress-bar p-b-r"  
                              v-b-tooltip.hover 
                              :title="`${topSubmissionTypes[2]?.quantity} ${$ml.get('reports')} ${ parseFloat(((topSubmissionTypes[2]?.quantity / sumSubmissionTypes) * 100).toFixed(1))}%`"
                              :style="`width: ${parseFloat((topSubmissionTypes[2]?.quantity / sumSubmissionTypes) * 100)}%`"> 
                            </div> 
                            <div class="progress-bar p-b-impact-low col"> </div>
                          </div>
                          <label>{{topSubmissionTypes[2]?.weakness_type}} - {{topSubmissionTypes[2]?.weakness_external_id}}</label>
                        </div>
                      </div> 
                  </div>
                </div>
              </div>

<!-- triaged -->
              <div class="col-sm-8 p-2 cardOverview" v-if="triaged.length" >
                <div class="card ">
                  <div class="card-body">
                    <h5 class="card-title" v-text="$ml.get('triaged')"></h5>
                    <apexchart type="donut" :width="widthChart" :height="heightChart" :options="triagedChart" :series="triagedChart.series"></apexchart>
                  </div>
                </div>
              </div>

 <!-- targets -->
              <div class="col-sm-8 p-2 cardOverview" v-if="topTargets.length > 3" >
                <div class="card">
                  <div class="card-body cardOverflow"> 
                    <h5 class="mb-4">Targets</h5> 
                    <ProgressImpact v-for="(item, index) in topTargets" :key="index" :targets="item" class="mt-1 mr-1"/> 
                  </div>

                </div>
              </div>
                
            </div> 
          </div> 
 
        </div>
      </div>
 
    </section>
  </main>
</div> 
</template>
 
<script>
  
import ReportService from "../../../services/report.service";
import Swal from 'sweetalert2' 
 
export default {
  components: {  
  },
  data() {
    return { 
      nameEmpresa: "",
    
      vulnerabilities: [],
      vulnerabilitiesTotal: 0,

      topTargets: [],

      metrics: [],
 
      vulnerabilitiesChart: {},

      submissionsChart: {},

      triaged: "",
      triagedChart: {},

      resolvedChart: {},

      awardedBountiesChart: {},

      topSubmissionTypes: {},
      sumSubmissionTypes: 0,

      widthChart: 380,
      heightChart: 155,
      sizeDonut: 80,
      offsetXPie: 85,
      currency: "",
     
    };
  },
 
  mounted() {
    this.currency = this.$store.getters['getUser']?.currency;
    this.nameEmpresa =  this.$store.getters['getUser'].name; 
    this.loadData();
  },
  methods: {

    loadData(){
   
      ReportService.getOverview().then(
        (response) => { 
 
          let resp = response?.data;  

          this.topSubmissionTypes = resp.topSubmissionTypes;

          console.log(this.topSubmissionTypes);
 
          this.topSubmissionTypes.forEach(element => {
            this.sumSubmissionTypes += element?.quantity;
          });

          this.metrics = resp.metrics;

          this.createVulnChart(resp.vulnerabilities);
 
          this.createSubChart(resp.submissions);

          this.triaged = resp.triaged;
          this.createTriagedChart(resp.triaged);

          this.createResolvedChart(resp.resolved);

          this.createAwardedBountiesChart(resp.awardedBounties);
  
          this.topTargets = resp.topTargets;
  
        },
        () => {
          Swal.fire({
            icon: 'info',
            title: '',
            text: this.$ml.get('unableToCompleteThisRequest'),
          }) 
        }
      ); 
    }, 
    
    createAwardedBountiesChart(awardedBounties){
  
      let series = [];
      let labels = [];
      let colors = []; 

      var self = this;
 
      awardedBounties.map((item) => {  

        if(item.severity == 'critical'){  
          series[0] = item.paid_value;
          labels[0] = 'critical';
          colors[0] = '#ba91f0';
        }

        if(item.severity == 'high'){  
          series[1] = item.paid_value;
          labels[1] = 'high';
          colors[1] = '#FEC5B0';
        }

        if(item.severity == 'medium'){  
          series[2] = item.paid_value;
          labels[2] = 'medium';
          colors[2] = '#FFF7DA';
        }

        if(item.severity == 'low'){  
          series[3] = item.paid_value;
          labels[3] = 'low';
          colors[3] = '#f1f1f1';
        }

        if(item.severity == 'informative'){  
          series[4] = item.paid_value;
          labels[4] = 'informative';
          colors[4] = '#f8f9fa';
        } 
      })
 
      this.awardedBountiesChart = { 
        chart: { 
          type: 'donut', 
          offsetX: -15,
          float: true
        }, 
        plotOptions: {
          pie: {
            offsetX: this.offsetXPie,
            donut: {
              size: this.sizeDonut,
              labels: {
                show: true, 
                total: {
                  show: true, 
                  label: "",
                  fontSize: 1,
                  formatter: function (w) {
                    const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                    return self.currency === 'USDT' ? self.$utils.convertDollar(total) : self.$utils.convertMoney(total);
                  }
                },
                value: { 
                  show: true, 
                  fontSize: 12,
                  offsetY: -8,
                  formatter: function(val) {
                    return self.currency === 'USDT' ? self.$utils.convertDollar(val) : self.$utils.convertMoney(val)
                  },
                }
              }
            }
          }
        }, 
        labels: labels.filter(n => n)?.map(l => this.$ml.get(l)),  
        colors: colors.filter(n => n), 
        series: series.filter(n => n), 
        dataLabels: {
          enabled: false
        },
        legend: {
          floating: true,
          formatter: function(val, opts) {
            return `
            ${val} <b class="end-legend">${self.currency === 'BRL' ? self.$utils.convertMoney(opts.w.globals.series[opts.seriesIndex]) : self.$utils.convertDollar(opts.w.globals.series[opts.seriesIndex])}</b> `
          },
          position: 'left',
          offsetY: 0,
        }, 
      } 
    },
    
    createResolvedChart(resolved){
      let series = [];
      let labels = [];
      let colors = [];
      let total = 0;


      resolved.map((item) => { 
        total += item?.quantity

        if(item.severity == 'critical'){  
          series[0] = item?.quantity;
          labels[0] = 'critical';
          colors[0] = '#ba91f0';
        }

        if(item.severity == 'high'){  
          series[1] = item?.quantity;
          labels[1] = 'high';
          colors[1] = '#FEC5B0';
        }

        if(item.severity == 'medium'){  
          series[2] = item?.quantity;
          labels[2] = 'medium';
          colors[2] = '#FFF7DA';
        }

        if(item.severity == 'low'){  
          series[3] = item?.quantity;
          labels[3] = 'low';
          colors[3] = '#f1f1f1';
        }

        if(item.severity == 'informative' || item.severity == 'none'){  
          series[4] = item?.quantity;
          labels[4] = 'informative';
          colors[4] = '#f8f9fa';
        } 
      })

      this.resolvedChart = {
        total: total,
        chart: { 
          type: 'donut', 
          offsetX: -15,
        }, 
        plotOptions: {
          pie: {
            offsetX: this.offsetXPie,
            donut: {
              size: this.sizeDonut,
              labels: {
                show: true,
                total: {
                  show: true, 
                  label: "",
                  fontSize: 1

                },
                value: { 
                  fontSize: 16,
                  show: true, 
                  offsetY: -8
                }
              }
            }
          }
        }, 
        labels: labels?.map((l) => this.$ml.get(l)), 
        colors: colors,
        series: series,
        dataLabels: {
          enabled: false
        },
        legend: {
          floating: true,
          formatter: function(val, opts) {
            return `${val} - ${opts.w.globals.series[opts.seriesIndex]}`
          },
        position: 'left',
        offsetY: 0,  
        },
  
      }
    },
    
    createTriagedChart(triaged){
      // const self = this;
      let series = [];
      let labels = [];
      let colors = [];


      triaged.map((item) => { 

        if(item.severity == 'critical'){  
          series[0] = item?.quantity;
          labels[0] = 'critical';
          colors[0] = '#ba91f0';
        }

        if(item.severity == 'high'){  
          series[1] = item?.quantity;
          labels[1] = 'high';
          colors[1] = '#FEC5B0';
        }

        if(item.severity == 'medium'){  
          series[2] = item?.quantity;
          labels[2] = 'medium';
          colors[2] = '#FFF7DA';
        }

        if(item.severity == 'low'){  
          series[3] = item?.quantity;
          labels[3] = 'low';
          colors[3] = '#f1f1f1';
        }

        if(item.severity == 'informative'){  
          series[4] = item?.quantity;
          labels[4] = this.$ml.get('informative');
          colors[4] = '#f8f9fa';
        } 
      })
 
      this.triagedChart = {
        chart: { 
          type: 'donut', 
          offsetX: -15, 
        }, 
        plotOptions: {
          pie: { 
            offsetX: this.offsetXPie,
            donut: {
              size: this.sizeDonut,
              labels: {
                show: true,
                total: {
                  show: true, 
                  label: "",
                  fontSize: 1

                },
                value: { 
                  fontSize: 16,
                  show: true, 
                  offsetY: -8
                }
              }
            }
          }
        }, 
        labels: labels.filter(n => n)?.map(l => this.$ml.get(l)), 
        colors: colors.filter(n => n), 
        series: series.filter(n => n), 
        dataLabels: {
          enabled: false
        },
        legend: {
          floating: true,
          formatter: function(val, opts) {
            return `${val} - ${opts.w.globals.series[opts.seriesIndex]}`  
          },
        position: 'left',
        offsetY: 0,  
        },
  
      }
    },
    
    createVulnChart(vulnerabilities){
      let series = [];
      let labels = [];
      let colors = [];

      vulnerabilities.map((item) => { 
        if(item.severity == 'critical'){  
          series[0] = item?.quantity;
          labels[0] = 'critical';
          colors[0] = '#ba91f0';
        }

        if(item.severity == 'high'){  
          series[1] = item?.quantity;
          labels[1] = 'high';
          colors[1] = '#FEC5B0';
        }

        if(item.severity == 'medium'){  
          series[2] = item?.quantity;
          labels[2] = 'medium';
          colors[2] = '#FFF7DA';
        }

        if(item.severity == 'low'){  
          series[3] = item?.quantity;
          labels[3] = 'low';
          colors[3] = '#f1f1f1';
        }

        if(item.severity == 'informative'){  
          series[4] = item?.quantity;
          labels[4] = 'informative';
          colors[4] = '#f8f9fa';
        } 
      })

      this.vulnerabilitiesChart = {
        chart: {
          offsetX: -40,
          type: 'donut',
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270
          }
        },
        labels: labels.filter(n => n)?.map(l => this.$ml.get(l)), 
        colors: colors.filter(n => n), 
        series: series.filter(n => n), 
        dataLabels: {
          enabled: false
        }, 
        legend: {
          show: false
        }
      }

      this.vulnerabilitiesTotal = vulnerabilities.map(item => item?.quantity).reduce((prev, curr) => prev + curr, 0);
    },

    createSubChart(submissions){
      let series = [];
      let labels = [];
      let total = 0;

      submissions.map((item) => { 
        series.push(item?.quantity);
        total += item?.quantity;
        labels.push(this.$ml.get(item.situation)); 
      })
       
      this.submissionsChart = {
        total: total,
        chart: { 
          type: 'donut', 
          offsetX: -15,           
        }, 
        plotOptions: {
          // this.offsetXPie
          pie: { 
            offsetX:100,
            donut: {
              size: this.sizeDonut, 
              labels: {
                show: true,
                total: {
                  show: true, 
                  label: "",
                  fontSize: 1

                },
                value: {  
                  fontSize: 16,
                  show: true, 
                  offsetY: -8, 
                }
              }
            }
          }
        }, 
        labels: labels, 
        series: series,
        colors: ['#f1f1f1', '#FFF7DA', '#FEC5B0', 'rgba(186, 145, 240, 0.831372549)', '#f8f9fa'],
        dataLabels: {
          enabled: false
        },
        legend: {
          floating: true, 
          formatter: function(val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex]
          },
          position: 'left',
          show: true,
          offsetY: 0,
        }, 
      }
    }
  },
};
</script>

<style lang="scss">
.apexcharts-tooltip {
  color: #373d3f !important;
}

.cardOverflow {
  overflow: auto;
  max-height: 401px;
}
 
.cardOverview {
  min-height: 234px;  
  min-width: 380px !important; 
  /* width */
  ::-webkit-scrollbar {
    margin: 7px;
    width: 7px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    margin: 7px;
    box-shadow: inset 0 0 5px grey; 
    border-radius: 10px;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    margin: 7px;
    background: #c1c1c1; 
    border-radius: 10px;
  }
}
 
</style>
 
 